import { types } from "mobx-state-tree";

import { endpoints } from "../api/ApiEndpoints";
import { StorageModel } from "../storage/StorageModel";
import { translationService } from "../translation/TranslationService";

interface CountryDisplay {
  id: string;
  name: string;
}

export const AvailableCountriesModel = types.model({
  availableCountries: types.optional(types.array(types.string), []),
});

export const AvailableCountriesStorageModel = types
  .compose(AvailableCountriesModel, StorageModel)
  .named("AvailableCountriesStorageModel")
  .actions((self) => {
    return {
      mapResponse(response: any) {
        self.availableCountries = response;
      },
      getAvailableCountries(): CountryDisplay[] {
        return self.availableCountries
          .map((c) => ({ id: c, name: translationService.translate(`general.country.${c}`) } as CountryDisplay))
          .sort((a, b) => ("" + a.name).localeCompare(b.name));
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("available_countries");
      return endpoint;
    },
    get isLoading() {
      return !self.availableCountries.length;
    },
  }));
